<template>
    <div
        class="box-el-wrapper"
        :class="{ 'greyscale unclickable': boxData.disabled }"
        :data-id="boxData.id"
        :data-name="boxData.name"
        :data-dd-action-name="boxData.name || boxData.title"
    >
        <div class="block" @click="handleOnClick">
            <img
                class="box-img lazyload"
                loading="lazy"
                :class="{ greyscale: boxData.available === false }"
                :src="boxData.image"
                :alt="`${boxData.name}`"
            />
        </div>
        <div class="text-container">
            <slot />
            <div class="main-text">{{ boxData.title }}</div>
            <p v-b-tooltip.hover.bottom="boxData.tooltip" class="description">{{ boxData.description }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { BoxData } from './index';

const props = defineProps<{ boxData: BoxData<unknown> }>();

const emit = defineEmits<{
    (e: 'click', value: BoxData): void;
}>();

const handleOnClick = () => {
    if (!props.boxData) return;

    emit('click', props.boxData);
};
</script>

<style lang="scss" scoped>
@import 'styles/utilities/functions';
.box-el-wrapper {
    cursor: pointer;
    width: 9.063rem;

    .block {
        display: flex;
        border-radius: 0.5rem;
        background: white;
        border: 1px solid #dee2e6;

        .box-img {
            width: 100%;
            border-radius: 0.5rem;
            object-fit: cover;
            &:hover,
            &:focus {
                border: 2px solid get-color('purple');
            }
        }
    }

    .text-container {
        letter-spacing: 0.14px;
        margin-top: 5px;

        .main-text {
            font-weight: bold;
            font-size: 14px;
        }
        .description {
            margin-bottom: 0;
            font-size: 10px;
        }
    }
    .greyscale {
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
    }

    .unclickable {
        pointer-events: none;
    }
}
</style>
